import { useState } from "react";
import { GridRowId } from "@mui/x-data-grid";
import { Box, Tabs, Tab } from "@mui/material";
import {
  AdminTemplate,
  RoleMenuAddModal,
  ServiceManagementAddModal,
  ServiceManagementListingTable,
  RoleTransferTab,
  BulkDeleteTab,
} from "../../components";
import { useAuthorization } from "../../hooks";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

export const SettingsServiceManagement = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [serviceManagementData, setServiceManagementData] = useState<any>();
  const [selectedTab, setSelectedTab] = useState(0);
  const { showCreate, showDelete } = useAuthorization();

  const handleAddButton = () => setIsOpen(true);
  const handleRowClick = (data: { id: GridRowId; row: any }) => {
    setIsOpen(true);
   setServiceManagementData(data.row);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Servis Yönetimi",
        onClickAddButton: selectedTab === 0 ? handleAddButton : undefined,
        hideAddButton: selectedTab !== 0,
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={selectedTab} onChange={handleTabChange} aria-label="service management tabs">
          <Tab label="Servis Listesi" />
          {showCreate && <Tab label="Toplu Servis Ekleme" />}
          {showDelete && <Tab label="Toplu Servis Silme" />}
        </Tabs>
      </Box>
      
      <TabPanel value={selectedTab} index={0}>
        <ServiceManagementListingTable isMenuOpen={isOpen} onRowClick={handleRowClick} />
      </TabPanel>
      
      {showCreate && (
        <TabPanel value={selectedTab} index={1}>
          <RoleTransferTab />
        </TabPanel>
      )}
      
      {showDelete && (
        <TabPanel value={selectedTab} index={showCreate ? 2 : 1}>
          <BulkDeleteTab />
        </TabPanel>
      )}

      {isOpen && (
        <ServiceManagementAddModal
          serviceManagement={serviceManagementData}
          onClose={() => {
            setIsOpen(false);
           setServiceManagementData(undefined);
          }}
          title={"Servis Yönetimi"}
          isOpen={isOpen}
        />
      )}
    </AdminTemplate>
  );
};
